import { Autocomplete, Backdrop, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { CSVLink } from "react-csv";
import ModalTable from "./modalTable";

const IndentSupplierReport = () => {
    const classes = useStyle()
    const dispatch = useDispatch();
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [data, setData] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [catData,setCatData] = useState([])
    const [subData,setSubData] = useState([])
    const [activeStep , setActiveStep] = useState("0")
    const [rowData , setRowData] = useState(null)
    const outletName = localStorage.getItem('outlet_name')
    const [allSubData, setAllSubData] = useState([]);
  const [open , setOpen] = useState(false)
  const[reorderDetails , setReorderDetails] = useState([])

    const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().startOf('month').format(),
    toDate :  moment().format()
  })
  const [options, setOptions] = useState({
    customer : null,
    category : null,
    subCategory : null
})
const onEdit = (e) => {
  console.log(e.row)
  setReorderDetails(e.row.indent_details_lines)
  setActiveStep("1")
  setRowData(e.row)
  setOpen(true)
}
function handleOptions(value, name){
    console.log(name, value)
    // setOptions(prev=>({...prev,[name] : value}))
    setOptions((prev) => ({ ...prev, [name]: value }));
        if (name === "category") {
          setOptions((prev) => ({ ...prev, subCategory: null }));
          filterSubCategories(value ? value.id : null);
        }
}
function filterSubCategories(categoryId) {
  if (categoryId) {
    const filteredSubData = allSubData.filter(
      (sub) => sub.category_id === categoryId
    );
    setSubData(filteredSubData);
  } else {
    setSubData([]);
  }
}
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
   {
    field: "supplier_name",
    headerName: "Supplier Name",
    flex: 1,
     minWidth : 170,
    maxWidth : 170,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  //  {
  //   field: "supplier_shortname",
  //   headerName: "Short Name",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    field: "pro_name",
    headerName: "Product Name",
        minWidth : 200,
    maxWidth : 200,
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
 
  {
    field: "pur_rate",
    headerName: "Pur Rate",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
  },
  {
    field: "sale_rate",
    headerName: "Sales Rate",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
  },
  {
    field: "wholesale_rate",
    headerName: "Wholesale Rate",
    flex: 1,
       minWidth : 170,
    maxWidth : 170,
    headerAlign: "center",
    align: "right",
    sortable: false,
  },
  {
    field: "mrp",
    headerName: "Mrp",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "gst",
    headerName: "Gst",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "cess",
    headerName: "Cess",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "hsn",
    headerName: "HSN",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "avgqtylast3months",
    headerName: "Sales",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "order_qty",
    headerName: "Order Qty",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },

]
console.log(options.customer != null ? options.customer.fullname : outletName)
const rows = _.map(data,(val,idx)=>({
  id: idx,
  sno: idx+1,
  pur_rate : val.pur_rate || 0,
  // item : val.pro_name,
  wholesale_rate : val.wholesale_rate || 0,
  mrp : val.mrp || 0,
  pro_name: val.pro_name || "-",
  supplier_name: val.supplier_name || "-",
  supplier_shortname: val.supplier_shortname || "-",
  gst: val.gst || 0,
  cess: val.cess || 0,
sale_rate:val.sale_rate || 0,
hsn:val.hsn || 0,
avgqtylast3months:val.avgqtylast3months || 0,
order_qty:val.order_qty || 0,
  indent_details_lines:val.indent_details_lines
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
  const tableHeadData = [
    { id:1, label: "S No" },
    { id:2, label: "Indent No" },
    { id:3, label: "Indent Date" },
    // { id:4, label: "Doc date" },
    { id:4 , label:"Product Name"},
    { id:5 , label:"Category"},
    { id:6 , label:"Subcategory"},
    { id:7 , label:"Type"},
    { id:8 , label:"Order Qty"},
    {id:9, label: 'Mrp'},
    {id:10, label: 'Gst'},
    // {id:9, label: 'Amount'},
  ];
  const tableBodyData = _.map(reorderDetails, (val,idx) => ({
    id:idx,
    sNo:idx+1,
    indent_no:val.indent_no,
    indent_date:val.indent_date,
    pro_name:val.pro_name,
        category_name:val.category_name,
    subcategory_name:val.subcategory_name,

    type_name:val.type_name,
    order_qty:val.order_qty,
    mrp: val.mrp,
    gst:val.gst,
    avgqtylast3months:val.avgqtylast3months,
    amount:Math.round(val.amount).toFixed(0),
    totalAmount : parseFloat( val.qty * val.amount ).toFixed(0)
  }))
  console.log(tableBodyData,"tableBodyDatadata");
  console.log(reorderDetails,"response");
  
// useEffect(() => {
//   // Calculate total balance amount
//   setTotalFlag(true)
//   let total = 0;

//   data.forEach(val => {
//       total += parseFloat(val.total_order_qty);
//   });
//   setTotalAmount(total.toFixed(0));
// }, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getCategory(){
    axios.get('/v1/categories')
    .then(res=>{
        _.filter(res.data, val=>{
            if(val.is_active){
                 setCatData(res.data)
            }
        })
    })
    .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function getSubCategory(){
    axios.get('/v1/subcategories')
    .then(res=>{
            // setSubData(res.data)
            setAllSubData(res.data);
    })
    .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function handleOutletSalesItemWise(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: options.customer !==null ? options.customer.id : 0,
      category : options.category !==null ? options.category.id : 0,
      subcategory : options.subCategory !==null ? options.subCategory.id : 0
  }
  axios.get(`/v1/indent/supplierwise/details/${rowsPerPage}/${page + 1}`)
  // axios.get(`/v1/indent/order/details/list/all/${options.customer !==null ? options.customer.id : 0}`)
  .then(res=>{
    setData(res?.data?.data)
    console.log(res?.data?.meta.pagination?.total_pages,"testresponse")
    setPageCount(res?.data?.meta.pagination?.total_pages)
  })
  .catch(err=>{
    setData([])
    dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
  })
}
const generateCSVData = () => {
  const csvData = [
    // ["Outlet Name",options.customer != null ? options.customer.fullname : outletName],
    // ["From Date", moment(dateLimit.fromDate).format('YYYY-MM-DD')],
    // ["To Date", moment(dateLimit.toDate).format('YYYY-MM-DD')],
    [],
    ["S.no", "Outlet Name", "Product Code", "Total Qty", "Amount", ]
  ];

  rows.forEach(row => {
    csvData.push([
      row.sno,
      row.otName,
      row.code,
      row.qty,
      row.amt,
    ]);
  });

  csvData.push([]);

  csvData.push(["", "", "", "Total Amount", totalAmount]);

  return csvData;
};
  useEffect(() => {
    getSupplierData();
    getCategory()
    getSubCategory()
  }, []);
  
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleOutletSalesItemWise()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit,options])
  console.log(rowsPerPage,page,pageCount,"rowsPerPage");
  
  return (
  <Fragment>
    <Helmet><title>Indent Supplierwise Reports</title></Helmet>
   <Typography variant="h6">Indent Supplierwise Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        {/* <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 , fullname :"All"} , ...supplier]}
            onChange={(e,value)=>handleOptions(value,'customer')}
            getOptionLabel={option=>option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid> */}
        {/* <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.category}
        options={catData}
        getOptionLabel={option=>option.category_name}
        onChange={(e,value)=>handleOptions(value,'category')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Category'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={subData}
        value={options.subCategory}
        disabled={options.category == null}
        getOptionLabel={option=>option.subcategory_name}
        onChange={(e,value)=>handleOptions(value,'subCategory')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Sub Category'/>
          )}
        />
      </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>

        </Grid>
        <Grid item md={3}>
          
        </Grid>
        <Grid item md={3} style={{ display: 'flex', alignItems: 'start',justifyContent:"end" }}>
          <CSVLink data={generateCSVData()} filename={"Outlet_Sales_Reorder_Reports.csv"}>
            <Button variant="contained" color="primary">
              Download CSV
            </Button>
          </CSVLink>
        </Grid> */}
      </Grid> 
 
       <CustomTable props={props}/> 
      
       <Backdrop open={open} sx={{zIndex:9999}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
       {/* <Grid>
        <ByProdId setActiveStep={setActiveStep} options={options} setOptions={setOptions} dateLimit={dateLimit} setDateLimit={setDateLimit} rowData={rowData}/>
       </Grid> */}
       
  </Fragment>
  )
}

export default memo(IndentSupplierReport)